import { getColumnInfo } from '../../../data/analyticsDataSlice';
import { TpDataTable } from '../../../data/interfaces';
import { TpChartConfigParams, TpChartDataBinding } from '../charts/chartDataBindings';
import { CONFIGPARAM_VISIBILITYCONDITION_TYPES, TpChartManifestConfigParamDef } from '../charts/interfaces';

export function checkConfigParamVisibilityConditions(
  dataTable: TpDataTable,
  configParamDef: TpChartManifestConfigParamDef,
  currentDataBinding: TpChartDataBinding,
  currentConfigParams: TpChartConfigParams,
) {
  const aspectBindings = currentDataBinding.aspectBindings;

  if (!configParamDef.visibilityConditions) return true;
  for (const condition of configParamDef.visibilityConditions) {
    if (condition.conditionType == CONFIGPARAM_VISIBILITYCONDITION_TYPES.FACET_BOUND) {
      const aspectBinding = aspectBindings[condition.conditionInfo.facet];
      if (!aspectBinding || !aspectBinding.columnId) return false;
      if (condition.conditionInfo.dataType) {
        const boundColumnInfo = getColumnInfo(dataTable, aspectBinding.columnId);
        if (condition.conditionInfo.dataType != boundColumnInfo.valueType) return false;
      }
    }
    if (condition.conditionType == CONFIGPARAM_VISIBILITYCONDITION_TYPES.FACET_UNBOUND) {
      const aspectBinding = aspectBindings[condition.conditionInfo.facet];
      if (aspectBinding && aspectBinding.columnId) return false;
    }
    if (condition.conditionType == CONFIGPARAM_VISIBILITYCONDITION_TYPES.CONFIG_VALUE) {
      if (currentConfigParams[condition.conditionInfo.configParam] != condition.conditionInfo.configValue) return false;
    }
    if (condition.conditionType == CONFIGPARAM_VISIBILITYCONDITION_TYPES.CONFIG_ABSENT) {
      if (
        currentConfigParams[condition.conditionInfo.configParam] !== null &&
        currentConfigParams[condition.conditionInfo.configParam] !== undefined &&
        !isNaN(currentConfigParams[condition.conditionInfo.configParam])
      )
        return false;
    }
    if (condition.conditionType == CONFIGPARAM_VISIBILITYCONDITION_TYPES.CONFIG_PRESENT) {
      const configParamValue = currentConfigParams[condition.conditionInfo.configParam];
      if (configParamValue == null || configParamValue === '') {
        return false;
      }
    }
    if (condition.conditionType == CONFIGPARAM_VISIBILITYCONDITION_TYPES.ANY_CONFIG_PRESENT) {
      const configParamValues = condition.conditionInfo.configParams.map(
        (configParam: string) => currentConfigParams[configParam],
      );
      if (configParamValues.every((configParamValue: any) => configParamValue == null)) {
        return false;
      }
    }
  }
  return true;
}

export function checkConfigParamConditions(
  dataTable: TpDataTable,
  configParamDef: TpChartManifestConfigParamDef,
  currentDataBinding: TpChartDataBinding,
  currentConfigParams: TpChartConfigParams,
) {
  if (configParamDef.hidden) return false;
  return checkConfigParamVisibilityConditions(dataTable, configParamDef, currentDataBinding, currentConfigParams);
}
